
import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { MessageSquare } from 'lucide-react';

interface MessageNodeProps {
  data: {
    label: string;
    description?: string;
    config?: {
      message?: string;
    }
  };
  selected: boolean;
}

export const MessageNode: React.FC<MessageNodeProps> = ({ data, selected }) => {
  const message = data.config?.message || 'Mensagem não configurada';
  
  return (
    <div className={`p-3 rounded-md border-2 ${selected ? 'border-primary' : 'border-border'} bg-card shadow-sm min-w-[200px]`}>
      <div className="flex items-center gap-2 font-medium text-sm mb-2">
        <MessageSquare className="w-4 h-4 text-blue-500" />
        {data.label}
      </div>
      
      <div className="p-2 bg-muted rounded-sm text-xs max-w-[250px] line-clamp-3">
        {message}
      </div>
      
      <Handle
        type="target"
        position={Position.Top}
        id="in"
        className="w-3 h-3 bg-muted-foreground border-2 border-background"
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="out"
        className="w-3 h-3 bg-primary border-2 border-background"
      />
    </div>
  );
};
